import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import learnMoreClick from 'commons/learnMoreClick';
import usePDPTieredPrice from 'data-hooks/usePDPTieredPrice';
import useUserData from 'data-hooks/useUserData';
import useAffirmRefreshHTML from 'hooks/useAffirmRefreshHTML';
import PDPFinancingUI from './PDPFinancingUI';
import usePdpIsModularBYOProduct from '../state/context/usePdpIsModularBYOProduct';

const PDPFinancing = ({ loading }) => {
  const { isTradeUser } = useUserData();
  const pdpIsModularBYOProduct = usePdpIsModularBYOProduct();
  const { loading: priceLoading, priceDetails } = usePDPTieredPrice();
  const affirmButtonRef = useRef();
  const showLearnMore = useAffirmRefreshHTML(affirmButtonRef);

  const price = !priceDetails?.hasDiscount
    ? priceDetails?.priceWithOptionsPrice
    : priceDetails?.hasTieredDiscount
    ? priceDetails?.maxTieredDiscountedPrice
    : priceDetails?.salePriceWithOptionsPrice;

  const numberOfMonths = price <= 1499 ? 12 : 18;
  const perMonthAmount = Math.round(price / numberOfMonths);

  const isLoading = loading || priceLoading;

  if (isTradeUser) {
    return null;
  }

  return priceLoading ? null : (
    <PDPFinancingUI
      loading={isLoading}
      affirmButtonRef={affirmButtonRef}
      numberOfMonths={numberOfMonths}
      onFinancingClick={() => {
        learnMoreClick(affirmButtonRef);
      }}
      pdpIsModularBYOProduct={pdpIsModularBYOProduct}
      perMonthAmount={perMonthAmount}
      price={price}
      showLearnMore={showLearnMore}
    />
  );
};

PDPFinancing.propTypes = {
  loading: PropTypes.bool,
};

export default PDPFinancing;
